import React from "react";
import { useState} from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars , faPhone} from '@fortawesome/free-solid-svg-icons';
// import {  faXmark} from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import Cross from "../assets/cross_icon.png" ;
import { faCaretDown ,  faTimes } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/TIRUN_LOGO.png' ;
// import CurrencySelector from "./CurrencySelector";

const Navbar =()=> {
        
    // const navigate = useNavigate();
    // const location = useLocation();
    // const [selectedPage, setSelectedPage] = useState('/');
  
    // Update dropdown based on current URL
    // useEffect(() => {
    //   setSelectedPage(location.pathname);
    // }, [location.pathname]);
  
    // const handleMobileNavChange = (e) => {
    //   const selectedValue = e.target.value;
    //   setSelectedPage(selectedValue);
    //   navigate(selectedValue);
    // };


    const [showModal, setShowModal] = useState(false);
      const [showSubNav, setShowSubNav] = useState(false);
    
      const handleSubNavToggle = () => {
        setShowSubNav(prev => !prev);
      };


    return(
        <>
        <div className="navbar-container">
            <div className="logo">
            <a href="https://tirun.com" target="_self">
            <img src={logo} alt="Tirun Logo" /></a>
            </div>

            <div className="navbar-item desktop-responsive" >
                <ul className="items">
                    {/* <li style={{fontSize:'1.3rem'}}>Get in touch with our Cruise Counsellor <FontAwesomeIcon icon={faPhone} style={{color: "#ffffff",marginLeft:'1vh',marginRight:'1.5vh'}} />
                    1800-11-5464</li>  */}
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/destinations">Destinations</Link></li>
                     <li onClick={handleSubNavToggle} style={{ position: 'relative', cursor: 'pointer' }}>
                     Our Cruise Lines <FontAwesomeIcon icon={faCaretDown} style={{color: "#ffffff",marginLeft:'5px'}} />
                    {showSubNav && (
            <ul className="sub-navbar" style={{
              listStyle:'none',
              position: 'absolute',
              top: '100%',
              left: 0,
              backgroundColor: '#061456',
              marginTop:'1vh',
              boxShadow: ' 2px 2px 10px rgba(0, 0, 0, 0.3)' ,
              padding: '10px',
              borderRadius: '5px',
              zIndex: 1000,
              minWidth: '200px',
              display:'flex' ,
              flexDirection :'column',
              gap:'8px',
              color:'#061456'
            }}>
              <li><Link to="/royalcaribbean" className="sub-link">Royal Caribbean</Link></li>
              <li><Link to="/silversea" className="sub-link">Silversea</Link></li> 
              <li><Link to="/celebritycruises" className="sub-link">Celebrity Cruises</Link></li>
              {/* <li><Link to="/Azamara" className="sub-link">Azamara</Link></li> */}
            </ul>
              )}
                    </li>

                    <li><Link to="/cruisedeals">Cruise Deals</Link></li>
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                </ul>

            </div>    

            {/* Mobile Button */}
      <div className="mobile-menu-links">
        <button onClick={() => setShowModal(true)} className="menu-button">
          Menu
        </button>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button onClick={() => setShowModal(false)} className="close-button">
              <FontAwesomeIcon icon={faTimes}  style={{color:"white"}}/>
            </button>
    
            <ul className="modal-nav">
              <li><Link to="/" onClick={() => setShowModal(false)}>Home</Link></li>
              <li><Link to="/destinations" onClick={() => setShowModal(false)}>Destinations</Link></li>
              <li onClick={handleSubNavToggle} style={{ cursor: 'pointer' }}>
                Our Cruise Lines <FontAwesomeIcon icon={faCaretDown} style={{marginLeft:"1vh"}}/>
                {showSubNav && (
                  <ul className="sub-navbar-modal">
                    <li><Link to="/royalcaribbean" onClick={() => setShowModal(false)}>Royal Caribbean</Link></li>
                    <li><Link to="/silversea" onClick={() => setShowModal(false)}>Silversea</Link></li>
                    <li><Link to="/celebritycruises" onClick={() => setShowModal(false)}>Celebrity Cruises</Link></li>
                  </ul>
                )}
              </li>
              <li><Link to="/cruisedeals" onClick={() => setShowModal(false)}>Cruise Deals</Link></li>
              <li><Link to="/about" onClick={() => setShowModal(false)}>About Us</Link></li>
              <li><Link to="/contact" onClick={() => setShowModal(false)}>Contact Us</Link></li>
            </ul>
          </div>
        </div>
      )}

        {/* <div className="mobile-menu-links" >
            <select  onChange={handleMobileNavChange} id="page-link"  value={selectedPage} >
              <option value="/ ">Home</option>
              <option value="/destinations ">Destinations</option>
              <option value="/royalcaribbean">Royal Caribbean</option>
              <option value="/silversea">Silversea</option>
              <option value="/celebritycruises">Celebrity Cruises</option>
              <option value="/about" >About Us</option>
              <option value="/cruisedeals" >Cruise Deals</option>
              <option value="/contact" >Contact Us</option>
            </select>
        </div> */}
            <div className="navbar-contact" >
               
<FontAwesomeIcon icon={faPhone} style={{color: "#ffffff",}} />
                <p>1800-11-5464</p>


            </div>

            {/* <div className="navbar-dropdown">
                <select>
                    <option>USD</option>
                    <option>SGD</option>
                    <option>INR</option>
                </select> */}
                {/* <FontAwesomeIcon icon={faCaretDown} style={{color: "#ffffff",}} /> */}
            {/* </div> */}
            {/* <CurrencySelector/> */}

            <div className="sidebar">
           
            <button class="btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"> <FontAwesomeIcon icon={faBars} style={{color: '#ffffff', width:'20px', height:'25px'}} /></button>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">



  <div class="offcanvas-header">
    <div className="offcanvas-header-style">
    <a href="https://tirun.com" target="_self">
        <img src={logo} alt="Tirun Logo"/></a>
    </div>
    {/* <button type="button" class="button-close" data-bs-dismiss="offcanvas" aria-label="Close"><FontAwesomeIcon icon={faXmark} style={{color: '#ffffff', width:'20px', height:'25px'}} /></button> */}
    <button type="button" class="button-close" data-bs-dismiss="offcanvas" aria-label="Close"><img src={Cross} alt="cross" style={{color: '#ffffff', width:'20px', height:'20px'}} /></button>

  </div>

  <div class="offcanvas-body" style={{width:'95%',padding:'2vh 4vh'}}>
  <p class="offcanvas-title" id="offcanvasRightLabel"><span style={{fontWeight:'800'}}>TIRUN Travel Marketing </span> is the Pioneer of Cruising in the Indian Subcontinent and <span style={{fontWeight:'800'}}>Exclusively represents four cruise brands, three owned by the Royal Caribbean Group, namely, Royal Caribbean International, Celebrity Cruises and Silversea, and Azamara Cruises.</span> <br></br></p>
 <br></br> 

 <h6 style={{marginTop:'2vh'}}>Phone or Email Us</h6>
 <p>Toll-Free: 1800-11-5464 <br></br>International: +91-11-4906 1000<br></br>online@tirun.com<br></br></p>

 <br></br><i>Headquartered in New Delhi, the company has its brands online to book and also an on-ground presence PAN India.</i>

 <h6 style={{marginTop:'2vh'}}>Address</h6>
    <p>505 Salcon Aurum, Jasola District Centre, New Delhi, 110025</p>

  <i>When you book with TIRUN, you become part of our <span style={{fontWeight:'800'}}>30+ years of partnership with our cruise brands!</span></i>
  <br></br>

   
    
   
   
  </div>
</div>
            </div>
        </div>
        </>

    );
}


export default Navbar;